function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $aa9669b2e3bd2bce$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"8iaq1":"operators_login.55859eda.js","fGXy0":"profileicon.16a903b8.png","96ZKV":"vm_routes_logo.df69fac7.svg","dyU8n":"mailverifyImg.f31f925f.png","qv2wt":"eyeOpen.66357690.svg","ejQJX":"eyeClose.d126f8fd.svg","336zr":"operator_login_background.0faa0c40.png","fQk2O":"client_login.1c7aa8d7.css"}'));

var $076353eda2b1ccde$export$2e2bcd8739ae039 = {
    "samples": true,
    "production": ""
};


var $a21b2ca73d4a80ca$export$2e2bcd8739ae039 = {
    "samples": (0, $076353eda2b1ccde$export$2e2bcd8739ae039)["production"] == "" && (0, $076353eda2b1ccde$export$2e2bcd8739ae039)["samples"] ? true : false,
    "socketProxyUrl": `${(0, $076353eda2b1ccde$export$2e2bcd8739ae039)["production"]}/`,
    "proxyUrl": `${(0, $076353eda2b1ccde$export$2e2bcd8739ae039)["production"]}/api`,
    "proxyAppUrl": `${(0, $076353eda2b1ccde$export$2e2bcd8739ae039)["production"]}/app`,
    "backendUrl": `http://localhost:1997/officeride/api`,
    "livedrivers": `https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php`,
    "ride_request_now": `https://api.not.nammaoorutaxi.com/cabs/dispatchrequest.php?notime=1&requestid=`,
    "ridelaterrequests": `https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php`,
    "ride_request_now_selective": `https://api.not.nammaoorutaxi.com/cabs/dispatchrequesttodriver.php`,
    "ridelatersolverroutes": `https://nammaoorutaxi.com/vrs/solver/rideshare/solve`,
    "driverlists": `https://api.not.nammaoorutaxi.com/cabs/list/driversdetails.php`,
    "driverapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-default.php?token=fsdfsdfsdfsdfdfs`,
    "driverofficerideapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-officeride.php?token=fsdfsdfsdfsdfdfs`,
    "driveraccountapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-account.php?token=fsdfsdfsdfsdfdfs`,
    "driversbasedetails": `https://api.not.nammaoorutaxi.com/cabs/list/fetchDrivers.php`,
    "mapmatching": `https://nammaoorutaxi.com/livetracking/api/get?id=`,
    "gps_tracking_local": `http://127.0.0.1:1253/gps-tracker/get-historical-data`,
    "gps_tracking": `https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-historical-data`,
    "gps_tracking_total": `https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-total-data`,
    "createridelaterrequest": `https://api.not.nammaoorutaxi.com/cabs/createridelaterrequest.php`
};


var $c652de0b7012a42f$exports = {};

$c652de0b7012a42f$exports = new URL((parcelRequire("27Lyk")).resolve("fGXy0"), import.meta.url).toString();


class $9b3365ae6fcec634$var$SystemNotification {
    constructor({ globalStore: globalStore  }){
        this.globalStore = globalStore;
        this.mapContainer = document.querySelector(".project-main");
        this.init();
    }
    init() {
        this.makeContainer();
        this.addEvents();
    }
    makeContainer() {
        let container = document.createElement("div");
        container.classList.add("system-notification-container");
        container.innerHTML = `
            <div class="content">
                <span class="message">Are you sure to Delete Project</span>
                <div class='btn-cancel' style="width: unset">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="rgba(0,0,0,0.7)"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>
                </div>
            </div>
            <div class="timer">
                <div class='timer-remains' id='timer-remains'></div>
            </div>
        `;
        this.container = container;
    }
    timerRemainder(time = 2000) {
        let timeRemainder = this.container.querySelector(".timer-remains");
        let cancelBtn = this.container.querySelector(".btn-cancel");
        const timerRemainderAnimate = [
            {
                width: "0%"
            },
            {
                width: "100%"
            }
        ];
        const timerRemainderAnimateOptions = {
            duration: time,
            iterations: 1
        };
        timeRemainder.animate(timerRemainderAnimate, timerRemainderAnimateOptions);
        setTimeout(()=>{
            const containerAnimate = [
                {
                    transform: " translateX(0)"
                },
                {
                    transform: "translateX(100%)"
                }
            ];
            const containerAnimateOption = {
                duration: 200,
                iterations: 1
            };
            this.container.animate(containerAnimate, containerAnimateOption);
        }, time);
        setTimeout(()=>this.hide(), time + 200);
    }
    addEvents() {
        let cancelBtn = this.container.querySelector(".btn-cancel");
        cancelBtn.addEventListener("click", ()=>{
            this.hide();
        });
    }
    warning(message, time = 4000) {
        if (message) {
            let msg = this.container.querySelector(".message");
            msg.style.color = "red";
            msg.innerHTML = message;
        }
        this.mapContainer.appendChild(this.container);
        this.timerRemainder(time);
    }
    success(message, time = 4000) {
        if (message) {
            let msg = this.container.querySelector(".message");
            msg.style.color = "var(--active-num)";
            msg.innerText = message;
        }
        this.mapContainer.appendChild(this.container);
        this.timerRemainder(time);
    }
    show(message, time = 4000) {
        if (message) {
            let msg = this.container.querySelector(".message");
            msg.innerHTML = message;
        }
        this.mapContainer.appendChild(this.container);
        this.timerRemainder(time);
    }
    hide() {
        if (this.mapContainer.querySelector(".system-notification-container")) this.mapContainer.removeChild(this.container);
    }
}
var $9b3365ae6fcec634$export$2e2bcd8739ae039 = $9b3365ae6fcec634$var$SystemNotification;


var $ae2a4bef19dd635e$exports = {};

$ae2a4bef19dd635e$exports = new URL((parcelRequire("27Lyk")).resolve("96ZKV"), import.meta.url).toString();


var $1f0dbab66cb7e624$exports = {};

$1f0dbab66cb7e624$exports = new URL((parcelRequire("27Lyk")).resolve("dyU8n"), import.meta.url).toString();






var $2a2cc04b43b9d441$exports = {};

$2a2cc04b43b9d441$exports = new URL((parcelRequire("27Lyk")).resolve("qv2wt"), import.meta.url).toString();


var $d8561a03c59283c2$exports = {};

$d8561a03c59283c2$exports = new URL((parcelRequire("27Lyk")).resolve("ejQJX"), import.meta.url).toString();


var $f3c614f8c5d91f4d$exports = {};

$f3c614f8c5d91f4d$exports = new URL((parcelRequire("27Lyk")).resolve("336zr"), import.meta.url).toString();




class $23882fa38398f286$var$EncryptionDB {
    constructor(){
        this.dbName = "EncryptionDB";
        this.storeName = "keys";
        this.dbVersion = 1;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.dbName, this.dbVersion);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                if (!db.objectStoreNames.contains(this.storeName)) db.createObjectStore(this.storeName, {
                    keyPath: "id"
                });
            };
            request.onsuccess = (event)=>{
                resolve(event.target.result);
            };
            request.onerror = (event)=>{
                reject(event.target.error);
            };
        });
    }
    async storeKeys(pkey, sharedKey, encryptedSharedKey) {
        const db = await this.openDB();
        const transaction = db.transaction([
            this.storeName
        ], "readwrite");
        const store = transaction.objectStore(this.storeName);
        const keyData = {
            id: "encryptionKeys",
            pkey: pkey,
            sharedKey: sharedKey,
            encryptedSharedKey: encryptedSharedKey
        };
        store.put(keyData);
        return transaction.complete;
    }
    async getKeys() {
        const db = await this.openDB();
        const transaction = db.transaction([
            this.storeName
        ], "readonly");
        const store = transaction.objectStore(this.storeName);
        return new Promise((resolve, reject)=>{
            const request = store.get("encryptionKeys");
            request.onsuccess = (event)=>{
                resolve(event.target.result);
            };
            request.onerror = (event)=>{
                reject(event.target.error);
            };
        });
    }
    async updateKey(keyName, newValue) {
        const db = await this.openDB();
        const transaction = db.transaction([
            this.storeName
        ], "readwrite");
        const store = transaction.objectStore(this.storeName);
        const request = store.get("encryptionKeys");
        request.onsuccess = (event)=>{
            const keys = event.target.result || {};
            keys[keyName] = newValue;
            store.put(keys);
        };
        request.onerror = (event)=>{
            console.error("Failed to retrieve keys from IndexedDB:", event.target.error);
        };
    }
}
var $23882fa38398f286$export$2e2bcd8739ae039 = $23882fa38398f286$var$EncryptionDB;


class $811012d04708c7ec$var$LoginUiController {
    constructor(globalStore, container){
        this.globalStore = globalStore || {};
        this.container = container || document.querySelector(".project-main");
        this.systemNotification = new (0, $9b3365ae6fcec634$export$2e2bcd8739ae039)({
            globalStore: globalStore
        });
        this.rigisterForm = new (0, $fe78b3b6eba3cf2c$export$2e2bcd8739ae039)(globalStore);
        this.resendBtn = false;
        this._init();
    }
    _init() {
        this.ui = this._makeloginUi();
        this.addEvents();
    }
    _makeloginUi() {
        this.container.innerHTML = `
        <img class="login-background-image" src="${0, (/*@__PURE__*/$parcel$interopDefault($f3c614f8c5d91f4d$exports))}" />
        <div class="login-upper-container">
            <div class="login-inner-container operator-login-tab">
                
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($ae2a4bef19dd635e$exports))}" alt="" class="logo-image">
                
                <p class="login-title-tab">OPERATOR LOGIN</p>

                <form action="#!" class="login-form-tab">

                    <label class="login-label-tag">Email Address</label>
                    <div class="login-input-container" id='login_email_parent'>
                        <input class="login-user-input" type="email" name="email" id="email" required placeholder="email@example.com">
                        <div class='project-login-email-error-msgs'>
                            <i class='bx bxs-info-circle'></i>
                            <span id='email-error-msg'> Please enter your email address using the format name@example.com</span>
                        </div>
                    </div>
        
                    <label class="login-label-tag">Password</label>
                    <div class="login-input-container" id='login_password_parent'>
                        <input class="login-user-input" name="password" id="password" required type="password" placeholder="Enter Password">
                        <img class="login-password-icon" src="${0, (/*@__PURE__*/$parcel$interopDefault($d8561a03c59283c2$exports))}">
                    </div>

                </form>
    
                <div class="login-add-on-buttons">
                    <div class="remember-me-container">
                        <input type="checkbox" value="lsRememberMe" class="remember-me" id="rememberMe"> <label
                            for="rememberMe">Remember me</label>
                    </div>
                    
                    <a href="#!" id="forgotBtn" class="login-forgot-password">Forgot Password ?</a>
                </div>

                <div class="login-submit-button-container">
                    <button class="login-submit-button" name="login" id="login" value="Login">Login</button>
                </div>

                <p class="login-wrapper-footer-text register-here-btn-new">Don't have an account? <a href="#!" class="text-reset" id="registerBtn">Register here</a></p>
    
            </div>
        </div>
            `;
        return this.container;
    }
    addEvents() {
        let loginForm = this.ui.querySelector("form");
        let registerBtn = this.ui.querySelector("#registerBtn");
        let forgotBtn = this.ui.querySelector("#forgotBtn");
        let loginBtn = this.ui.querySelector("#login");
        let input_email = this.ui.querySelector("#email");
        let input_password = this.ui.querySelector("#password");
        let email_error_msgs = this.ui.querySelector(".project-login-email-error-msgs");
        let showPassword = this.ui.querySelector(".login-password-icon");
        showPassword.addEventListener("click", ()=>{
            if (showPassword.src == (0, (/*@__PURE__*/$parcel$interopDefault($2a2cc04b43b9d441$exports)))) {
                showPassword.src = (0, (/*@__PURE__*/$parcel$interopDefault($d8561a03c59283c2$exports)));
                input_password.type = "password";
            } else {
                showPassword.src = (0, (/*@__PURE__*/$parcel$interopDefault($2a2cc04b43b9d441$exports)));
                input_password.type = "text";
            }
        });
        function verifyEmail(value) {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
        }
        let login_btn_event = ()=>{
            let isUpperAlpha_email = !new RegExp("(?=.*[A-Z])").test(input_email.value);
            verifyEmail(input_email.value) && isUpperAlpha_email && input_password.value.length;
        };
        input_password?.addEventListener("input", function() {
            login_btn_event();
        });
        input_email?.addEventListener("input", function() {
            login_btn_event();
        });
        input_email?.addEventListener("change", function() {
            let isUpperAlpha = new RegExp("(?=.*[A-Z])").test(input_email.value);
            if (!verifyEmail(input_email.value) || isUpperAlpha) email_error_msgs.style.display = "flex";
            else email_error_msgs.style.display = "none";
        });
        function generateRandomId(length = 16) {
            const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result = "";
            for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
            return result;
        }
        loginBtn.addEventListener("click", async (e)=>{
            e.preventDefault();
            let email = loginForm.querySelector('input[name="email"]').value;
            let password = loginForm.querySelector('input[name="password"]').value;
            let deviceId = generateRandomId();
            if (!email || !password) return this.systemNotification.warning("Please enter email and password");
            let response = await fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-device-identifier": deviceId
                },
                body: JSON.stringify({
                    email: email,
                    password: password
                })
            });
            try {
                let jsonRes = await response.json();
                if (!jsonRes.status) {
                    this.systemNotification.warning(jsonRes.message);
                    return jsonRes;
                } else {
                    if (jsonRes.data.isregisterVerified == 0) {
                        this.rigisterForm.makeVerfiyOTPForm(email, jsonRes.data, true);
                        return;
                    } else if (jsonRes.data.isregisterVerified == 1) {
                        this.rigisterForm.makeRegisterForm(email);
                        return;
                    } else if (jsonRes.data.isregisterVerified == 2) {
                        let db = new (0, $23882fa38398f286$export$2e2bcd8739ae039)();
                        await db.storeKeys(jsonRes.publicKey);
                        localStorage.setItem("deviceId", deviceId);
                        localStorage.setItem("x-access-token", jsonRes.data.token);
                        history.replaceState(null, null, (0, $076353eda2b1ccde$export$2e2bcd8739ae039).production + "/operator");
                        window.location.href = (0, $076353eda2b1ccde$export$2e2bcd8739ae039).production + "/operator";
                    }
                }
            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err));
            }
        });
        forgotBtn.addEventListener("click", (e)=>{
            e.preventDefault();
            let forgotContainer = this._makeforgotUi(loginForm);
            this.addEventsToForgot(forgotContainer);
        });
        registerBtn.addEventListener("click", (e)=>{
            e.preventDefault();
            this.rigisterForm._init();
        });
    }
    _makeforgotUi(loginForm) {
        document.querySelector(".login-add-on-buttons").style.display = "none";
        document.querySelector(".login-submit-button-container").style.display = "none";
        loginForm.innerHTML = `

            <label class="login-label-tag" for="email">Email Address</label>
            <div class="login-input-container" id='login_email_parent'>
                <input class="login-user-input" type="email" name="email" id="email" required placeholder="email@example.com">
                <div class='project-login-email-error-msgs'>
                    <i class='bx bxs-info-circle'></i>
                    <span id='email-error-msg'> Please enter your email address using the format name@example.com</span>
                </div>
            </div>

            <div class="login-submit-button-container send-otp-container-tab">
                <input name="login" id="reset" class="login-submit-button" type="submit" value="Send OTP">
            </div>
        
        `;
        return loginForm;
    }
    _makeVerifyOTPUI(forgotContainer, email) {
        forgotContainer.innerHTML = `
            <div class="form-group mb-4">
                <label for="password">OTP</label>
                <div id='inputs'>
                    <input id='input1' required class="optInput" type='text' maxLength="1" />
                    <input id='input2' required class="optInput" type='text' maxLength="1" />
                    <input id='input3' required class="optInput" type='text' maxLength="1" />
                    <input id='input4' required class="optInput" type='text' maxLength="1" />
                    <input id='input5' required class="optInput" type='text' maxLength="1" />
                    <input id='input6' required class="optInput" type='text' maxLength="1" />
                </div>
            </div>
            <p style="color: #000;float: right;"><a href="#!" class="text-reset" id="resendBtn">Resend OTP</a></p>
            <input name="login" id="optBtn" class="btn btn-block login-btn" type="submit" value="Verify OTP">
        `;
        return forgotContainer;
    }
    _makeResetPasswordUI(forgotContainer, email) {
        forgotContainer.innerHTML = `
            <div class="form-group">
                <label for="email">Email</label>
                <input type="email" name="email" id="email" value="${email}" disabled required class="form-control" placeholder="email@example.com">
            </div>
            <div class="form-group mb-4">
                <label for="password">Password</label>
                <input type="password" name="password" id="password" required class="form-control" placeholder="enter your passsword">
            </div>
            <input name="login" id="resetPassword" class="btn btn-block login-btn" type="submit" value="Reset Password">
        `;
        return forgotContainer;
    }
    addEventsToForgot(forgotContainer) {
        let input_email = forgotContainer.querySelector("#email");
        let resetBtn = forgotContainer.querySelector("#reset");
        let email_error_msgs = forgotContainer.querySelector(".project-login-email-error-msgs");
        function verifyEmail(value) {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
        }
        let email_events = ()=>{
            input_email.addEventListener("change", function() {
                if (!verifyEmail(input_email.value)) email_error_msgs.style.display = "flex";
                else email_error_msgs.style.display = "none";
            });
        };
        email_events();
        resetBtn.addEventListener("click", async (e)=>{
            e.preventDefault();
            let email = forgotContainer.querySelector('input[name="email"]').value;
            if (!email) return this.systemNotification.warning("Please enter email");
            let response = await fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/forget-password", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email
                })
            });
            try {
                let jsonRes = await response.json();
                if (!jsonRes.status) {
                    this.systemNotification.warning(jsonRes.message);
                    return jsonRes;
                } else {
                    let verfiyOTPContainer = this._makeVerifyOTPUI(forgotContainer);
                    this.addEventsToVerifyOTP(verfiyOTPContainer, email);
                }
            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err));
            }
        });
    }
    addEventsToVerifyOTP(forgotContainer, email) {
        let optBtn = forgotContainer.querySelector("#optBtn");
        let resendBtn = forgotContainer.querySelector("#resendBtn");
        const inputs = [
            "input1",
            "input2",
            "input3",
            "input4",
            "input5",
            "input6"
        ];
        inputs.map((id)=>{
            const input = document.getElementById(id);
            addListener(input);
        });
        function addListener(input) {
            input.addEventListener("keyup", (event)=>{
                const code = parseInt(input.value);
                if (code >= 0 && code <= 9) {
                    const n = input.nextElementSibling;
                    if (n) n.focus();
                } else input.value = "";
                const key = event.key; // const {key} = event; ES6+
                if (key === "Backspace" || key === "Delete") {
                    const prev = input.previousElementSibling;
                    if (prev) prev.focus();
                }
            });
        }
        resendBtn.addEventListener("click", async (e)=>{
            e.preventDefault();
            if (this.resendBtn) return;
            if (!email) return this.systemNotification.warning("Please enter email");
            let response = await fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/resend-forget-password-code", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email
                })
            });
            try {
                let jsonRes = await response.json();
                if (!jsonRes.status) {
                    this.systemNotification.warning(jsonRes.message);
                    return jsonRes;
                } else this.systemNotification.success(jsonRes.message);
            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err));
            }
            this.countdown(forgotContainer);
            this.resendBtn = true;
            e.target.classList.add("disabled");
        });
        optBtn.addEventListener("click", async (e)=>{
            e.preventDefault();
            let otp = "";
            inputs.map((id)=>{
                const input = document.getElementById(id);
                otp += input.value;
            });
            if (!email || !otp) return this.systemNotification.warning("Please enter email and code");
            let response = await fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/verify-forgetPassword", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    code: otp
                })
            });
            try {
                let jsonRes = await response.json();
                if (!jsonRes.status) {
                    this.systemNotification.warning(jsonRes.message);
                    return jsonRes;
                } else {
                    let resetPasswordContainer = this._makeResetPasswordUI(forgotContainer, email);
                    this.addEventsToResetPassword(resetPasswordContainer, email);
                }
            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err));
            }
        });
    }
    countdown(container) {
        var seconds = 60;
        let tick = ()=>{
            const timeElement = container.querySelector("#resendBtn");
            seconds--;
            timeElement.innerHTML = "0:" + (seconds < 10 ? "0" : "") + String(seconds);
            if (seconds > 0) setTimeout(tick, 1000);
            else {
                timeElement.innerHTML = "Resend OTP";
                timeElement.classList.remove("disabled");
                this.resendBtn = false;
            }
        };
        tick();
    }
    addEventsToResetPassword(forgotContainer, email) {
        let resetPasswordBtn = forgotContainer.querySelector("#resetPassword");
        resetPasswordBtn.addEventListener("click", async (e)=>{
            e.preventDefault();
            let password = forgotContainer.querySelector('input[name="password"]').value;
            if (!email || !password) return this.systemNotification.warning("Please enter email and password");
            // Password must be at least 8 characters, include one number and one special character
            const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
            if (!passwordRegex.test(password)) return this.systemNotification.warning("Password must be at least 8 characters long and include at least one number and one special character.");
            let response = await fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/reset-Password", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    password: password
                })
            });
            try {
                let jsonRes = await response.json();
                if (!jsonRes.status) window.location.href = "/operator/login";
                else {
                    this.systemNotification.warning("Password reset successfully");
                    window.location.reload();
                }
            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err));
            }
        });
    }
}
var $811012d04708c7ec$export$2e2bcd8739ae039 = $811012d04708c7ec$var$LoginUiController;





class $fe78b3b6eba3cf2c$var$RegisterControllerUI {
    constructor(globalStore, container){
        this.globalStore = globalStore || {};
        this.container = container || document.querySelector(".project-main");
        this.systemNotification = new (0, $9b3365ae6fcec634$export$2e2bcd8739ae039)({
            globalStore: globalStore
        });
        this.resendBtn = false;
    // this._init()
    }
    _init() {
        let emailVerifyForm = this.makeEmailVerifyForm();
        this.container.innerHTML = "";
        this.container.appendChild(emailVerifyForm);
        this.addEmailsEvents();
    }
    makeRegisterForm(email) {
        this.ui = this._makeRegisterUi();
        this.emailAddress = email || "";
        this.addEvents();
    }
    makeEmailVerifyForm() {
        let emailVerifyForm = document.createElement("div");
        emailVerifyForm.innerHTML = `
            <img class="login-background-image" src="${0, (/*@__PURE__*/$parcel$interopDefault($f3c614f8c5d91f4d$exports))}" />
            <div class="login-upper-container">
                <div class="login-inner-container operator-login-tab">
                    <p class="login-title-tab">OPERATOR REGISTER</p>

                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($ae2a4bef19dd635e$exports))}" alt="" class="logo-image">
                    
                    <form class="login-form-tab">

                        <label class="login-label-tag">Email Address</label>
                        <div class="login-input-container" id='login_email_parent'>
                            <input class="login-user-input email-user-input" type="email" name="email" id="emailInput" required placeholder="email@example.com" autocomplete="off">
                            <div class='project-login-email-error-msgs'>
                                <i class='bx bxs-info-circle'></i>
                                <span id="emailError" class="error"></span>
                            </div>
                        </div>
            
                        <label class="login-label-tag">Password</label>
                        <div class="login-input-container" id='login_password_parent'>
                            <input class="login-user-input password-user-input" name="password" id="passwordInput" required type="password" placeholder="Enter Password" autocomplete="off">
                            <img class="login-password-icon" src="${0, (/*@__PURE__*/$parcel$interopDefault($d8561a03c59283c2$exports))}">
                            <span id="passwordError" class="error"></span>
                        </div>

                        <div class="login-submit-button-container">
                            <button class="login-submit-button" type="submit">Send OTP</button>
                        </div>

                    </form>

                    <p class="login-wrapper-footer-text register-here-btn-new">You have an account? <a href="#!" class="text-reset" id="loginBtn">Login here</a></p>
        
                </div>
            </div>
        `;
        return emailVerifyForm;
    }
    addEmailsEvents() {
        let form = this.container.querySelector("form");
        let emailInput = this.container.querySelector("#emailInput");
        let emailError = this.container.querySelector("#emailError");
        let passwordInput = this.container.querySelector("#passwordInput");
        let loginBtn = this.container.querySelector("#loginBtn");
        let emailErrorContainer = this.container.querySelector(".project-login-email-error-msgs");
        let showPassword = this.container.querySelector(".login-password-icon");
        showPassword.addEventListener("click", ()=>{
            if (showPassword.src == (0, (/*@__PURE__*/$parcel$interopDefault($2a2cc04b43b9d441$exports)))) {
                showPassword.src = (0, (/*@__PURE__*/$parcel$interopDefault($d8561a03c59283c2$exports)));
                passwordInput.type = "password";
            } else {
                showPassword.src = (0, (/*@__PURE__*/$parcel$interopDefault($2a2cc04b43b9d441$exports)));
                passwordInput.type = "text";
            }
        });
        form.addEventListener("submit", async (e)=>{
            e.preventDefault();
            let email = emailInput.value;
            let password = passwordInput.value;
            if (!email) {
                emailErrorContainer.style.display = "block";
                emailError.innerHTML = "Please Enter Email Address";
                return;
            }
            if (!this.validateEmail(email)) {
                emailErrorContainer.style.display = "block";
                emailError.innerHTML = "Please Enter Valid Email Address";
                return;
            }
            emailErrorContainer.style.display = "none";
            let response = await fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    password: password
                })
            });
            response = await response.json();
            if (response.status) {
                this.systemNotification.success(response.message);
                this.makeVerfiyOTPForm(email);
                this.emailAddress = email;
            } else {
                this.systemNotification.warning(response.message);
                emailError.innerHTML = response.message;
            }
        });
        loginBtn.addEventListener("click", (e)=>{
            e.preventDefault();
            let loginUiController = new (0, $811012d04708c7ec$export$2e2bcd8739ae039)(this.globalStore, this.container);
        // loginUiController._init()
        });
    }
    validateEmail(email) {
        // Regular expression for basic email validation
        const pattern = /^[a-zA-Z0-9._%\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // Use the test() method to check if the email matches the pattern
        return pattern.test(email);
    }
    makeVerfiyOTPForm(email, data, isVerify = false) {
        this.container.innerHTML = `
        <img class="login-background-image" src="${0, (/*@__PURE__*/$parcel$interopDefault($f3c614f8c5d91f4d$exports))}" />
        <div class="login-upper-container">
            <div class="login-inner-container operator-login-tab">
                <p class="login-title-tab">OTP</p>

                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($ae2a4bef19dd635e$exports))}" alt="" class="logo-image">

                <svg width="80" height="60" viewBox="0 0 292 208" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1_45)">
                        <path
                        d="M152.106 208C201.536 208 241.606 167.93 241.606 118.5C241.606 69.0706 201.536 29 152.106 29C102.676 29 62.6058 69.0706 62.6058 118.5C62.6058 167.93 102.676 208 152.106 208Z"
                        fill="#C5FFFF" />
                        <path
                        d="M117.144 64.4241C113.81 64.4241 111.108 67.1261 111.108 70.46V167.057C111.108 170.391 113.81 173.093 117.144 173.093H186.572C189.906 173.093 192.608 170.391 192.608 167.057V92.382L163.507 64.4241H117.144Z"
                        fill="#91E4FF" />
                        <path d="M192.608 92.382H169.544C166.21 92.382 163.508 89.68 163.508 86.3461V64.4241L192.608 92.382Z"
                        fill="#0CB4EA" />
                        <path
                        d="M162.304 131.646C162.304 135.494 159.185 138.613 155.339 138.613H104.483C100.635 138.613 97.5186 135.494 97.5186 131.646V110.363C97.5186 106.515 100.635 103.397 104.483 103.397H155.339C159.185 103.397 162.304 106.515 162.304 110.363V131.646Z"
                        fill="#0CB4EA" />
                        <path
                        d="M117.094 114.409C118.563 114.409 119.825 114.707 120.876 115.302C121.93 115.897 122.728 116.745 123.267 117.843C123.807 118.941 124.079 120.23 124.079 121.712C124.079 122.808 123.932 123.803 123.635 124.697C123.338 125.592 122.894 126.369 122.302 127.025C121.71 127.681 120.981 128.184 120.119 128.532C119.257 128.879 118.266 129.053 117.153 129.053C116.044 129.053 115.054 128.875 114.178 128.518C113.302 128.16 112.571 127.657 111.985 127.005C111.398 126.354 110.956 125.572 110.656 124.658C110.358 123.744 110.208 122.755 110.208 121.692C110.208 120.604 110.364 119.604 110.676 118.697C110.99 117.788 111.442 117.017 112.034 116.378C112.627 115.739 113.349 115.253 114.198 114.914C115.047 114.574 116.012 114.409 117.094 114.409ZM121.17 121.692C121.17 120.655 121.003 119.756 120.669 118.997C120.334 118.238 119.856 117.663 119.233 117.273C118.612 116.883 117.899 116.688 117.093 116.688C116.521 116.688 115.991 116.795 115.504 117.012C115.017 117.228 114.599 117.542 114.247 117.954C113.897 118.367 113.621 118.893 113.416 119.534C113.214 120.176 113.113 120.895 113.113 121.694C113.113 122.499 113.214 123.226 113.416 123.877C113.621 124.527 113.907 125.067 114.277 125.495C114.647 125.923 115.073 126.244 115.552 126.456C116.031 126.668 116.558 126.775 117.131 126.775C117.866 126.775 118.54 126.592 119.154 126.224C119.77 125.857 120.259 125.29 120.623 124.524C120.988 123.757 121.17 122.813 121.17 121.692Z"
                        fill="white" />
                        <path
                        d="M134.976 117.018H131.846V127.306C131.846 127.898 131.713 128.338 131.45 128.625C131.187 128.912 130.844 129.054 130.425 129.054C130 129.054 129.654 128.909 129.388 128.619C129.121 128.33 128.987 127.892 128.987 127.305V117.017H125.856C125.366 117.017 125.003 116.909 124.765 116.693C124.528 116.477 124.408 116.192 124.408 115.838C124.408 115.47 124.532 115.181 124.779 114.969C125.028 114.757 125.387 114.649 125.858 114.649H134.977C135.473 114.649 135.842 114.76 136.082 114.977C136.326 115.196 136.446 115.483 136.446 115.836C136.446 116.189 136.323 116.475 136.078 116.691C135.834 116.907 135.466 117.018 134.976 117.018Z"
                        fill="white" />
                        <path
                        d="M143.642 123.297H141.015V127.306C141.015 127.879 140.879 128.313 140.609 128.61C140.339 128.907 139.997 129.054 139.584 129.054C139.152 129.054 138.804 128.907 138.542 128.614C138.279 128.322 138.146 127.891 138.146 127.324V116.409C138.146 115.777 138.291 115.326 138.581 115.056C138.871 114.786 139.331 114.65 139.963 114.65H143.643C144.733 114.65 145.568 114.734 146.154 114.902C146.734 115.063 147.235 115.33 147.657 115.703C148.079 116.077 148.399 116.534 148.619 117.076C148.84 117.617 148.947 118.224 148.947 118.901C148.947 120.344 148.503 121.437 147.615 122.182C146.726 122.926 145.4 123.297 143.642 123.297ZM142.945 116.804H141.014V121.133H142.945C143.622 121.133 144.188 121.062 144.64 120.921C145.095 120.78 145.44 120.548 145.678 120.226C145.917 119.904 146.036 119.483 146.036 118.959C146.036 118.335 145.853 117.826 145.485 117.433C145.074 117.013 144.228 116.804 142.945 116.804Z"
                        fill="white" />
                        <rect x="233.582" y="79" width="10" height="10" rx="1" transform="rotate(27.2727 233.582 79)" fill="#91A3FF" />
                        <circle cx="74" cy="139" r="5" fill="#FF91B9" />
                        <circle cx="79" cy="43" r="5" fill="#91E5FF" />
                        <circle cx="188" cy="203" r="5" fill="#FF9191" />
                    </g>
                    <circle cx="220" cy="15" r="5" fill="#FFC691" />
                    <circle cx="119.606" cy="5" r="5" fill="#91FFAF" />
                    <rect x="250.606" y="163" width="10" height="10" rx="1" fill="#E991FF" />
                    <rect x="274" y="47.0925" width="10" height="10" rx="1" transform="rotate(-24.1576 274 47.0925)" fill="#FF9191" />
                    <rect y="68.5666" width="10" height="10" rx="1" transform="rotate(-27.1716 0 68.5666)" fill="#91A3FF" />
                    <path d="M33.0121 175.265L40.7499 180.821L32.0689 184.744L33.0121 175.265Z" fill="#FF9191" />
                    <path d="M15.077 128.971L16.567 138.38L7.67356 134.966L15.077 128.971Z" fill="#FD91FF" />
                    <path d="M286.447 120.204L287.505 129.672L278.777 125.854L286.447 120.204Z" fill="#FF91BF" />
                    <defs>
                        <clipPath id="clip0_1_45">
                        <rect width="179" height="179" fill="white" transform="translate(62.6058 29)" />
                        </clipPath>
                    </defs>
                </svg>
                
                <form class="login-form-tab" style="font-size:16px; margin:10px 0; text-align:center;">

                    <div class="title" style="font-weight:bold; margin:5px 0;">Verification Code</div>
                    <p>We have sent a verification code to your Email Address</p>

                    <div id='inputs' style="margin:30px 0;">
                        <input id='input1' required class="optInput" type='text' maxLength="1" style="font-weight:bold;" />
                        <input id='input2' required class="optInput" type='text' maxLength="1" style="font-weight:bold;" />
                        <input id='input3' required class="optInput" type='text' maxLength="1" style="font-weight:bold;" />
                        <input id='input4' required class="optInput" type='text' maxLength="1" style="font-weight:bold;" />
                        <input id='input5' required class="optInput" type='text' maxLength="1" style="font-weight:bold;" />
                        <input id='input6' required class="optInput" type='text' maxLength="1" style="font-weight:bold;" />
                    </div>
                    <p style="color: #33cdff;text-align: right;margin-top: 1rem;"><a href="#!" class="text-reset" id="resendBtn">Resend OTP</a></p>

                    <div class="login-submit-button-container">
                        <button class="login-submit-button" type="submit">Submit</button>
                    </div>

                </form>
    
            </div>
        </div>
        
        `;
        const inputs = [
            "input1",
            "input2",
            "input3",
            "input4",
            "input5",
            "input6"
        ];
        inputs.map((id)=>{
            const input = document.getElementById(id);
            addListener(input);
        });
        function addListener(input) {
            input.addEventListener("keyup", (event)=>{
                const code = parseInt(input.value);
                if (code >= 0 && code <= 9) {
                    const n = input.nextElementSibling;
                    if (n) n.focus();
                } else input.value = "";
                const key = event.key; // const {key} = event; ES6+
                if (key === "Backspace" || key === "Delete") {
                    const prev = input.previousElementSibling;
                    if (prev) prev.focus();
                }
            });
        }
        this.container.querySelector("#resendBtn").addEventListener("click", (e)=>{
            e.preventDefault();
            if (this.resendBtn) return;
            this.resendOTP(email);
            this.countdown(this.container);
            this.resendBtn = true;
        });
        this.container.querySelector("form").addEventListener("submit", (e)=>{
            e.preventDefault();
            let otp = "";
            inputs.map((id)=>{
                const input = document.getElementById(id);
                otp += input.value;
            });
            this.verifyOTP(email, otp);
        });
        if (isVerify) this.resendOTP(email);
    }
    countdown(container) {
        var seconds = 60;
        let tick = ()=>{
            const timeElement = container.querySelector("#resendBtn");
            seconds--;
            timeElement.innerHTML = "0:" + (seconds < 10 ? "0" : "") + String(seconds);
            if (seconds > 0) setTimeout(tick, 1000);
            else {
                timeElement.innerHTML = "Resend OTP";
                timeElement.classList.remove("disabled");
                this.resendBtn = false;
            }
        };
        tick();
    }
    async resendOTP(email) {
        let response = await fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/resend-registeration-code", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email
            })
        });
        response = await response.json();
        if (response.status) this.systemNotification.success(response.message);
        else this.systemNotification.warning(response.message);
    }
    async verifyOTP(email, otp) {
        await fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/verify-registeration", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                code: otp
            })
        }).then((response)=>response.json()).then((response)=>{
            if (response.status) {
                this.systemNotification.success(response.message);
                this.emailAddress = email;
                this.makeRegisterForm(email);
            } else this.systemNotification.warning(response.message);
        });
    }
    _makeRegisterUi(data = {}) {
        this.container.innerHTML = `        
            <div class="brand-wrapper">
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($ae2a4bef19dd635e$exports))}" alt="logo" class="logo">
            </div>
            <h2 style="text-align: center; margin-bottom: 1rem;">Register</h2>
            <form class="add-driver add-operator">
                <div class="body-container" style="align-items: unset;">
                    <div class="personal-details" id="personal-details">
                        <div class="addnew-header profile-header-name">Personal Details</div>
                
                        <div class="profile-container-driver">
                            <div class="profile-picture">
                                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($c652de0b7012a42f$exports))}" class="profilepic" id="profileImage" alt="Profile Picture" />
                
                            </div>
                            <div class="profile-details">
                                <span style="font-size:1.8vh; font-weight: 600;" class="profile-header-name">Profile Picture<br></span>
                                <span style="font-size: 1.5vh;color:#9e9e9e;">Maximum size: 2 MB, Minimum Resolution: 100px, Format: JPG,
                                    PNG<br></span>
                                <button id="browseButton" class="highlight browse  " type="button"
                                    style="border: solid 1px #0096ff;background-color: #f0f9ff;width: 88px;height: 32px;border-radius: 4px;margin:1.5vh 0vh">
                                    <span class="browse">Browse</span>
                
                                </button>
                                <input type="file" accept="image/*" class="remove " id="user_pic" style="display: none;"
                                    data-default="true">
                            </div>
                        </div>
                
                        <div class="details" style="margin: 0">
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">Full Name</label>
                                <input type="text" value="" required="" class="personal-input form-add-input  personalreq"
                                    placeholder="Enter Full Name" name="name" />
                            </div>
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">Mobile Number</label>
                                <input type="text" value="" required=""
                                    class="personal-input form-add-input phone  personalreq" id="phoneno" name="phone_number"
                                    placeholder="Mobile Number" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
                            </div>
                            <div class="addnew-driver">
                                <label style="margin-left: 0;">Gender</label>
                                <select class="personal-select  personalreq" name="gender" required="">
                                    <option value="" disabled selected hidden>Select gender</option>
                                    <option style=" color: #757575;" value="0" >Male</option>
                                    <option value="1">Female</option>
                                    <option value="2">Other</option>
                                </select>
                            </div>
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">Date of Birth</label>
                                <input type="date" max="${new Date().toISOString().substring(0, 10)}" id="dob_driver" class="personal-input form-add-input  personalreq" name="dob"
                                    required="" />
                            </div>
                        </div>
                
                        <div class="details" style="margin: 0">
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">Door No</label>
                                <input type="text" value="" class="personal-input form-add-input  personalreq"
                                    placeholder=" Enter Door No" name="door_no" required="" />
                            </div>
                
                            <div class="addnew-driver">
                                <label style="margin-left: 0">Street</label>
                                <input type="text" value="" class="personal-input form-add-input  personalreq" required=""
                                    placeholder=" Enter Street" name="street" />
                            </div>
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">Area</label>
                                <input type="text" value="" class="personal-input form-add-input  personalreq" required=""
                                    placeholder="Enter Area" name="area" />
                            </div>
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">Country</label>
                                <select class="personal-select personalreq" id="country" name="country" required="">
                                    <option style=" color: #757575;">Select Country</option>
                                </select>
                            </div>
                
                        </div>
                        <div class="details" style="margin: 0">
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">State</label>
                                <select class="personal-select  personalreq" id="state" name="state" required="">
                                    <option style=" color: #757575;">Select State</option>
                                </select>
                            </div>
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">City</label>
                                <select id="city" class="personal-select personalreq drivername" name="city" required>
                                    <option value="">Select City</option>
                                </select>
                            </div>
                            <div class="addnew-driver">
                                <label class="form-add-label" style="margin-left: 0;">Pin Code</label>
                                <input type="text" value="" class="personal-input form-add-input  personalreq"
                                    placeholder=" Enter Pin Code" name="pincode" required="" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
                            </div>
                        </div>
                        <div class="addnew-header profile-header-name">Operator Documents</div>

                        <div class="details">
                            
                            <div class="addnew-driver">
                                <label style="margin-left: 1.5vh;">Aadhar Card Number</label>
                                <input type="text" class="aadhar-input docreq" required="" value=""
                                placeholder=" Enter Aadhar Card No" name="aadhar_no" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
                            </div>

                            <div class="addnew-driver">
                                <label style="margin-left: 1.5vh;margin-bottom:0.5vh;">Upload Documents</label>
                                <div class="driver-input-container">
                                <input type="text" class="form-add-input-browse" id="files" disabled placeholder="Aadhar Proof" readonly>
                                <label for="aadhar_proof" class="browsebtn">
                                    Browse
                                </label>
                                <input type="file" Id="aadhar_proof" class="aadhar_no docreq" style="display: none">
                                </div>
                            </div>

                        </div>

                        <div class="details">

                            <div class="addnew-driver">
                                <label style="margin-left: 1.5vh;">Pan Card Number</label>
                                <input type="text" required="" id="pancard_no" name="pan_no" class="aadhar-input docreq"
                                value="" placeholder=" Enter PAN Card No" oninput="this.value = this.value.toUpperCase();"
                                onKeyPress="if(this.value.length==10) return false;" />
                            </div>

                            <div class="addnew-driver">
                                <label style="margin-left:1.5vh;margin-bottom:0.5vh;">Upload Documents</label>
                                <div class="driver-input-container">
                                <input type="text" class="form-add-input-browse panbackground" placeholder="Pan Proof" id="panfiles" disabled
                                    readonly>
                                <label for="panInput" class="browsebtn" id="panbutton">
                                    Browse
                                </label>
                                <input type="file" id="pan_proof" class="docreq" style="display: none">
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="button-container">
                    <div class="addnew-button" style="align-items: center;justify-content: space-between;">
                        <p class="login-wrapper-footer-text">You have an account? <a href="#!" class="text-reset" id="loginBtn">Login here</a></p>
                        <button class="button" style="border: 1px solid #d3d3d3;" id="personal-submitbutton" type="submit" name="submit">
                            <span class="next">Register</span>
                        </button>
                    </div>
                </div>    
            </form>
        `;
        return this.container;
    }
    addEvents() {
        const countrySelect = document.getElementById("country");
        const stateSelect = document.getElementById("state");
        const citySelect = document.getElementById("city");
        async function loadCountries() {
            const res = await fetch("https://vendors.vmmaps.com/vmvendorsServer/api/countries/get-country", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    page: 1,
                    limit: 10000,
                    sort: 0
                })
            });
            const data = await res.json();
            data.data.forEach((country)=>{
                const option = document.createElement("option");
                option.value = country.id;
                option.textContent = country.name;
                countrySelect.appendChild(option);
            });
        }
        // Fetch states (or fallback to country name)
        async function loadStates(countryCode) {
            stateSelect.innerHTML = '<option value="">Select</option>';
            citySelect.innerHTML = '<option value="">Select</option>';
            const res = await fetch("https://vendors.vmmaps.com/vmvendorsServer/api/countries/get-states", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    code: parseInt(countryCode),
                    page: 1,
                    limit: 1000,
                    sort: 0
                })
            });
            const data = await res.json();
            if (!data.data || data.data.length === 0) {
                // Fallback: use country as state & city
                const selectedCountry = countrySelect.options[countrySelect.selectedIndex];
                if (selectedCountry) {
                    const fallbackOption = document.createElement("option");
                    fallbackOption.value = selectedCountry.value;
                    fallbackOption.textContent = selectedCountry.textContent;
                    stateSelect.appendChild(fallbackOption.cloneNode(true));
                    citySelect.appendChild(fallbackOption.cloneNode(true));
                }
                return;
            }
            // Normal state loading
            data.data.forEach((state)=>{
                const option = document.createElement("option");
                option.value = state.id;
                option.textContent = state.name;
                stateSelect.appendChild(option);
            });
        }
        // Fetch cities (or fallback to state name)
        async function loadCities(stateCode) {
            citySelect.innerHTML = '<option value="">Select</option>';
            const res = await fetch("https://vendors.vmmaps.com/vmvendorsServer/api/countries/get-cities", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    code: parseInt(stateCode),
                    page: 1,
                    limit: 10000,
                    sort: 0
                })
            });
            const data = await res.json();
            if (!data.data || data.data.length === 0) {
                // Fallback: use selected state as city
                const selectedState = stateSelect.options[stateSelect.selectedIndex];
                if (selectedState) {
                    const fallbackOption = document.createElement("option");
                    fallbackOption.value = selectedState.value;
                    fallbackOption.textContent = selectedState.textContent;
                    citySelect.appendChild(fallbackOption);
                }
                return;
            }
            // Normal city loading
            data.data.forEach((city)=>{
                const option = document.createElement("option");
                option.value = city.id;
                option.textContent = city.name;
                citySelect.appendChild(option);
            });
        }
        // Event Listeners
        countrySelect.addEventListener("change", (e)=>{
            const countryCode = e.target.value;
            if (countryCode) loadStates(countryCode);
        });
        stateSelect.addEventListener("change", (e)=>{
            const stateCode = e.target.value;
            if (stateCode) loadCities(stateCode);
        });
        // Initialize
        loadCountries();
        let loginBtn = this.container.querySelector("#loginBtn");
        loginBtn.addEventListener("click", ()=>{
            new (0, $811012d04708c7ec$export$2e2bcd8739ae039)(this.globalStore);
        });
        // document select browse
        const fileInput = document.querySelector("#aadhar_proof");
        const inputBox = document.querySelector("#files");
        fileInput.addEventListener("change", function() {
            const fileName = this.files[0]?.name;
            inputBox.value = fileName;
            inputBox.classList.add("tickstyle");
        });
        const browseBtn = document.querySelector(".browsebtn");
        browseBtn.addEventListener("click", function(event) {
            event.preventDefault();
            fileInput.click();
        });
        // pancard
        const panInput = document.querySelector("#pan_proof");
        const panBox = document.querySelector("#panfiles");
        panInput.addEventListener("change", function() {
            const fileName = this.files[0]?.name;
            panBox.value = fileName;
            panBox.classList.add("tickstyle");
        });
        const panBtn = document.querySelector("#panbutton");
        panBtn.addEventListener("click", function() {
            panInput.click();
        });
        this.addEventsToBrowseButton();
        this.addEventsToSubmitButton();
    }
    addEventsToBrowseButton() {
        let browseButton = this.ui.querySelector("#browseButton");
        let userPic = this.ui.querySelector("#user_pic");
        browseButton.addEventListener("click", ()=>{
            userPic.click();
        });
        userPic.addEventListener("change", ()=>{
            this._readURL(userPic);
        });
    }
    _readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function(e) {
                let profileImage = document.querySelector("#profileImage");
                profileImage.setAttribute("src", e.target.result);
            };
            reader.readAsDataURL(input.files[0]);
        }
    }
    addEventsToSubmitButton() {
        let submitButton = this.ui.querySelector("#personal-submitbutton");
        submitButton.addEventListener("click", (e)=>{
            e.preventDefault();
            this.submit();
        });
    }
    submit() {
        let userpic = this.container.querySelector("#user_pic").files[0];
        let aadhar_doc = this.container.querySelector("#aadhar_proof").files[0];
        let pan_doc = this.container.querySelector("#pan_proof").files[0];
        let piceditedflag = false;
        let formData = new FormData(this.ui.querySelector("form"));
        if (userpic) {
            formData.append("user_pic", userpic);
            piceditedflag = true;
        }
        if (aadhar_doc) {
            formData.append("aadhar_proof", aadhar_doc);
            piceditedflag = true;
        }
        if (pan_doc) {
            formData.append("pan_proof", pan_doc);
            piceditedflag = true;
        }
        if (piceditedflag == false) {
            this.systemNotification.warning("All fields are required. Please fill all the fields");
            return;
        }
        // Validate Aadhaar Number
        let validateAadhaar = (adhaarNumber)=>{
            const aadhaarNumberPattern = /^[2-9]\d{11}$/;
            return aadhaarNumberPattern.test(adhaarNumber);
        };
        let national_number = formData.get("aadhar_no");
        if (!validateAadhaar(national_number)) {
            this.systemNotification.warning("Enter a Valid Aadhaar Card Number");
            return;
        }
        // Validate Pin Code
        let validatePincode = (pincode)=>{
            const pinPattern = /([0-9]{6}|[0-9]{3}\s[0-9]{3})/;
            return pinPattern.test(pincode);
        };
        let pincodeValue = formData.get("pincode");
        if (!validatePincode(pincodeValue)) {
            this.systemNotification.warning("Enter a Valid Pin Code");
            return;
        }
        // Validate Mobile number
        let validateMobileNumber = (mobileNumber)=>{
            const mobileNumberPattern = /^[6-9]\d{9}$/;
            return mobileNumberPattern.test(mobileNumber);
        };
        let mobileNumber = formData.get("phone_number");
        if (!validateMobileNumber(mobileNumber)) {
            this.systemNotification.warning("Enter a Valid Mobile Number");
            return;
        }
        let pan_number = formData.get("pan_no");
        if (pan_number.length != 10) {
            this.systemNotification.warning("Pan number should be 10 digits");
            return;
        }
        // Get selected Country, State, City names
        let countrySelect = this.container.querySelector("#country");
        let stateSelect = this.container.querySelector("#state");
        let citySelect = this.container.querySelector("#city");
        // Get selected option text (name)
        let countryName = countrySelect.options[countrySelect.selectedIndex]?.text || "";
        let stateName = stateSelect.options[stateSelect.selectedIndex]?.text || "";
        let cityName = citySelect.options[citySelect.selectedIndex]?.text || "";
        // Append these names to formData
        formData.set("country", countryName);
        formData.set("state", stateName);
        formData.set("city", cityName);
        formData.append("national_number", national_number);
        formData.append("email", this.emailAddress);
        let response = fetch((0, $a21b2ca73d4a80ca$export$2e2bcd8739ae039)["proxyUrl"] + "/operator/update-registeration-detials", {
            method: "POST",
            headers: {},
            body: formData
        });
        response.then((res)=>res.json()).then((res)=>{
            if (res.status) {
                this.systemNotification.success("Operator Registered Successfully");
                new (0, $811012d04708c7ec$export$2e2bcd8739ae039)(this.globalStore);
            } else this.systemNotification.warning("Operator Registration Failed");
        });
    }
}
var $fe78b3b6eba3cf2c$export$2e2bcd8739ae039 = $fe78b3b6eba3cf2c$var$RegisterControllerUI;



class $06e57cb56a6aa85b$var$AuthenticationController {
    constructor(globalStore, init = true){
        this.mainContainer = document.querySelector(".project-main");
        this.globalStore = globalStore || {};
        this.mainPanels = [];
        if (init) this._init();
    }
    _init() {
        this.ui = this._makeConitainer();
        this.mainContainer.appendChild(this.ui);
        this.addEvents();
    }
    _makeConitainer() {
        let container = document.createElement("div");
        container.classList.add("authentication-container");
        let headerContainer = this._makeHeaderContainer();
        container.appendChild(headerContainer);
        this.__loginPanel = this._makeloginUi();
        container.appendChild(this.__loginPanel);
        this.mainPanels.push(this.__loginPanel);
        this.__registerPanel = this._makeRegisterUi();
        container.appendChild(this.__registerPanel);
        this.mainPanels.push(this.__registerPanel);
        return container;
    }
    _makeHeaderContainer() {
        let container = document.createElement("div");
        container.classList.add("tab-controller");
        container.innerHTML = `       
            <span class="properties-ui-login-header">Login</span>
            <span class="properties-ui-register-header">Register</span>
        `;
        return container;
    }
    _makeloginUi() {
        let container = document.createElement("div");
        container.classList.add("login-panel");
        return container;
    }
    _makeRegisterUi() {
        let container = document.createElement("div");
        container.classList.add("register-panel");
        return container;
    }
    addEvents() {
        this.addEventsToPropertiesHeader();
    }
    unSelectPanels() {
        let transformHeader = this.ui.querySelector(".properties-ui-login-header");
        transformHeader.classList.remove("properties-ui-selected-header");
        let attributeHeader = this.ui.querySelector(".properties-ui-register-header");
        attributeHeader.classList.remove("properties-ui-selected-header");
    }
    __hideAllPanels() {
        this.mainPanels.forEach((panel)=>panel.style.display = "none");
    }
    addEventsToPropertiesHeader() {
        this.loginformHeader = this.ui.querySelector(".properties-ui-login-header");
        this.loginformHeader.addEventListener("click", (e)=>{
            this.__hideAllPanels();
            new (0, $811012d04708c7ec$export$2e2bcd8739ae039)(this, this.__loginPanel);
            this.__loginPanel.style.display = "block";
            this.unSelectPanels();
            this.loginformHeader.classList.add("properties-ui-selected-header");
        });
        this.loginformHeader.click();
        this.registerHeader = this.ui.querySelector(".properties-ui-register-header");
        this.registerHeader.addEventListener("click", (e)=>{
            this.__hideAllPanels();
            new (0, $fe78b3b6eba3cf2c$export$2e2bcd8739ae039)(this, this.__registerPanel);
            this.__registerPanel.style.display = "Block";
            this.unSelectPanels();
            this.registerHeader.classList.add("properties-ui-selected-header");
        });
    }
}
var $06e57cb56a6aa85b$export$2e2bcd8739ae039 = $06e57cb56a6aa85b$var$AuthenticationController;



new (0, $811012d04708c7ec$export$2e2bcd8739ae039)({});


//# sourceMappingURL=operators_login.55859eda.js.map
